import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { Organisation } from '../types';

interface InvoicesFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  customerId: string;
  onCustomerChange: (value: string) => void;
  pageSize: number;
  onPageSizeChange: (value: number) => void;
  customers: Organisation[];
  isLoadingCustomers: boolean;
}

export function InvoicesFilters({
  search,
  onSearchChange,
  customerId,
  onCustomerChange,
  pageSize,
  onPageSizeChange,
  customers,
  isLoadingCustomers,
}: InvoicesFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search */}
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search invoices..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-64 pl-8"
        />
      </div>

      {/* Account Filter */}
      <Select value={customerId} onValueChange={onCustomerChange}>
        <SelectTrigger className="w-48">
          <SelectValue placeholder={isLoadingCustomers ? 'Loading...' : 'All Accounts'} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Accounts</SelectItem>
          {customers.map((customer) => (
            <SelectItem key={customer._id} value={customer._id}>
              {customer.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Page Size */}
      <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
        <SelectTrigger className="w-24">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="10">10</SelectItem>
          <SelectItem value="25">25</SelectItem>
          <SelectItem value="50">50</SelectItem>
          <SelectItem value="100">100</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
